import { Habilitation, HABILITATION_I18N } from '@pflegia/types/api/general/habilitation';
import { strictFormatNameWithTitles as baseStrictFormatNameWithTitles } from '@pflegia/util/common/format-name';

export const strictFormatNameWithTitles = baseStrictFormatNameWithTitles<Habilitation>(HABILITATION_I18N);
